"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[1132],{

/***/ 11982:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ex: () => (/* binding */ addItemsToPostponed),
  xE: () => (/* binding */ getClosestAvailableMonth),
  p8: () => (/* binding */ getPostponedItems),
  Q_: () => (/* binding */ getProductFromQueueByFlatIndex),
  Ln: () => (/* binding */ useQueue),
  Rx: () => (/* binding */ useQueueAddItems),
  xi: () => (/* binding */ useQueueDeleteItem),
  d_: () => (/* binding */ useQueueMoveItem),
  oB: () => (/* binding */ useQueueResolvePostponedItems),
  DE: () => (/* binding */ useQueueUpdateItem)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(8055);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__(73074);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__(97334);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(6135);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(62100);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(69453);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.unshift.js
var es_array_unshift = __webpack_require__(54644);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(96837);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(46781);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__(33273);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(40963);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.is-array.js
var es_array_is_array = __webpack_require__(75983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(81738);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(58738);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(61420);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useMutation.ts + 1 modules
var useMutation = __webpack_require__(41146);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useApolloClients.tsx
var useApolloClients = __webpack_require__(83115);
// EXTERNAL MODULE: ./local_modules/local-storage/index.ts + 2 modules
var local_storage = __webpack_require__(55222);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83901);
// EXTERNAL MODULE: ./src/helpers/getters/checkUpsellModalCookie.ts
var checkUpsellModalCookie = __webpack_require__(67525);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(31978);
// EXTERNAL MODULE: ./local_modules/notifications/manager.ts
var notifications_manager = __webpack_require__(72065);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(91339);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user_user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/modules/user/shownPopups/index.tsx + 2 modules
var user_shownPopups = __webpack_require__(86506);
// EXTERNAL MODULE: ./src/modules/user/optIn/index.ts
var optIn = __webpack_require__(64217);
;// CONCATENATED MODULE: ./src/modules/queue/modifyQueueItems.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var modifyQueueItems = function(queueItems) {
    return queueItems.map(function(queueItem) {
        var month = queueItem.month, year = queueItem.year, statuses = queueItem.statuses, paid = queueItem.paid, canceled = queueItem.canceled, products = queueItem.products, tracking = queueItem.tracking;
        var isSkipped = statuses.includes("SKIPPED");
        var isLocked = statuses.includes("LOCKED");
        var isShipped = statuses.includes("SHIPPED");
        var isPaused = statuses.includes("PAUSED");
        var isDelivered = (tracking === null || tracking === void 0 ? void 0 : tracking.status) === "DELIVERED";
        var hasAvailablePlace = statuses.some(function(status) {
            return status === "EMPTY" || status === "PRODUCT" || status === "FREE" || status === "FREE_FOR_REFEREE" || status === "FREE_FOR_REFERRAL";
        });
        var isDisabled = !hasAvailablePlace && (isSkipped || isLocked || isShipped);
        var isEmpty = products.length === 0;
        var modifiedProducts = statuses.map(function(status, index) {
            var queueProduct = products[index];
            var isEmpty = !(queueProduct === null || queueProduct === void 0 ? void 0 : queueProduct.tradingItem);
            var isUnavailable = status === "UNAVAILABLE";
            var isFree = status === "FREE" || status === "FREE_GIFT" || status === "FREE_COUPON" || status === "FREE_FOR_REFEREE" || status === "FREE_FOR_REFERRAL";
            var isBlocked = status === "SKIPPED" || status === "SHIPPED" || status === "LOCKED";
            // it's for correct work of moveProduct / removeProduct methods
            var isMovable = !isBlocked && !isEmpty;
            return _object_spread_props(_object_spread({}, queueProduct), {
                status: status,
                stateOptions: {
                    isEmpty: isEmpty,
                    isFree: isFree,
                    isBlocked: isBlocked,
                    isMovable: isMovable,
                    isUnavailable: isUnavailable,
                    isDelivered: isDelivered
                }
            });
        });
        return {
            month: month,
            year: year,
            statuses: statuses,
            tracking: tracking,
            products: modifiedProducts,
            stateOptions: {
                isSkipped: isSkipped,
                isLocked: isLocked,
                isPaused: isPaused,
                isShipped: isShipped,
                isDelivered: isDelivered,
                isDisabled: isDisabled,
                isEmpty: isEmpty,
                isCancelled: canceled,
                isPaid: paid
            }
        };
    });
};
/* harmony default export */ const queue_modifyQueueItems = (modifyQueueItems);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(83464);
;// CONCATENATED MODULE: ./src/modules/queue/filterEmptyQueueItems.ts






var freeStatuses = [
    "FREE",
    "FREE_COUPON",
    "FREE_FOR_REFEREE",
    "FREE_FOR_REFERRAL",
    "FREE_GIFT"
];
// remove empty months to keep only one of them
var filterEmptyQueueItems = function(queueItems) {
    var emptyProductFound = false;
    var result = queueItems.filter(function(param) {
        var statuses = param.statuses, products = param.products;
        // if there are no products and user has some amount of free credits we should show the same amount of empty cells (see PF-544, scenario 14)
        var isFreeCreditFound = false;
        // if cell is empty or free but without product and we can fill it
        var emptyProductsCount = statuses.filter(function(status, index) {
            var isFreeCredit = freeStatuses.includes(status) && !products[index];
            isFreeCreditFound = isFreeCreditFound || isFreeCredit;
            return status === "EMPTY" || isFreeCredit;
        }).length;
        var isCompletelyEmpty = emptyProductsCount === statuses.length;
        // we don't need to show all the skipped months if we already show empty cells in previous months
        var shouldHideSkipped = emptyProductFound && statuses[0] === "SKIPPED";
        // if we already found item with empty product
        // and this empty item has no free credits
        // we can omit this empty item
        if (!isFreeCreditFound && emptyProductFound && isCompletelyEmpty || shouldHideSkipped) {
            return false;
        }
        var isPartiallyEmpty = emptyProductsCount > 0;
        if (isPartiallyEmpty) {
            emptyProductFound = true;
        }
        return true;
    });
    if (!emptyProductFound) {
        // if user filled the queue completely and backend doesn't return empty item,
        // we should add one
        var lastItem = result[result.length - 1];
        var nextMonth = lastItem.month === 12 ? 1 : lastItem.month + 1;
        var nextYear = lastItem.month === 12 ? lastItem.year + 1 : lastItem.year;
        result.push({
            month: nextMonth,
            year: nextYear,
            paid: false,
            canceled: false,
            tracking: null,
            statuses: lastItem.statuses.map(function() {
                return "EMPTY";
            }),
            products: []
        });
    }
    return result;
};
/* harmony default export */ const queue_filterEmptyQueueItems = (filterEmptyQueueItems);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(41964);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(94218);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(40045);
;// CONCATENATED MODULE: ./src/modules/queue/graph/queue.graphql.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}





var QueueDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "Queue"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "QueueInput"
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "currentUser"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "data"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "queue"
                                                },
                                                "arguments": [
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "input"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "input"
                                                            }
                                                        }
                                                    }
                                                ],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "queueItems"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "FragmentSpread",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "QueueItem"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "QueueItem"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "QueueItem"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "month"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "year"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paid"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "canceled"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "statuses"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "tracking"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "number"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "products"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "flatIndex"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "queueItemId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "drift"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "name"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "image"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "description"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "scentOfMonthUid"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "tradingItem"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "volume"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "volume"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "unit"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "productInfo"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "url"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "image"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "rebrandImage"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "rebrandLabels"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "marketing"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "extra"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "characteristic"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "fullName"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "brandInfo"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "slug"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "category"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "typeGroup"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "gender"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "upchargePrice"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasLep"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasVariety"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "isSubscribedToStockNotification"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
QueueDocument["definitions"] = _to_consumable_array(new Set(QueueDocument.definitions));
/* harmony default export */ const queue_graphql = (QueueDocument);

;// CONCATENATED MODULE: ./src/modules/queue/graph/queueAddMultipleItems.graphql.ts
function queueAddMultipleItems_graphql_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function queueAddMultipleItems_graphql_array_without_holes(arr) {
    if (Array.isArray(arr)) return queueAddMultipleItems_graphql_array_like_to_array(arr);
}
function queueAddMultipleItems_graphql_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function queueAddMultipleItems_graphql_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function queueAddMultipleItems_graphql_to_consumable_array(arr) {
    return queueAddMultipleItems_graphql_array_without_holes(arr) || queueAddMultipleItems_graphql_iterable_to_array(arr) || queueAddMultipleItems_graphql_unsupported_iterable_to_array(arr) || queueAddMultipleItems_graphql_non_iterable_spread();
}
function queueAddMultipleItems_graphql_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return queueAddMultipleItems_graphql_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return queueAddMultipleItems_graphql_array_like_to_array(o, minLen);
}





var QueueAddMultipleItemsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "QueueAddMultipleItems"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "mutationInput"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "QueueAddMultipleItemsInput"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "queueInput"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "QueueInput"
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "queueAddMultipleItems"
                        },
                        "arguments": [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "mutationInput"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "data"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "productsAdded"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "queue"
                                                },
                                                "arguments": [
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "input"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "queueInput"
                                                            }
                                                        }
                                                    }
                                                ],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "queueItems"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "FragmentSpread",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "QueueItem"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "error"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "QueueAddMultipleItemsError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "queueAddItemErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorDetails"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "tradingItemId"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "message"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "businessErrorCode"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "productValidationErrorCode"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "SecurityError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "securityErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "ServerError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "serverErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "ValidationError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "validationErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "QueueItem"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "QueueItem"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "month"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "year"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paid"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "canceled"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "statuses"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "tracking"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "number"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "products"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "flatIndex"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "queueItemId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "drift"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "name"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "image"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "description"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "scentOfMonthUid"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "tradingItem"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "volume"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "volume"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "unit"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "productInfo"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "url"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "image"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "rebrandImage"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "rebrandLabels"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "marketing"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "extra"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "characteristic"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "fullName"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "brandInfo"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "slug"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "category"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "typeGroup"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "gender"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "upchargePrice"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasLep"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasVariety"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "isSubscribedToStockNotification"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
QueueAddMultipleItemsDocument["definitions"] = queueAddMultipleItems_graphql_to_consumable_array(new Set(QueueAddMultipleItemsDocument.definitions));
/* harmony default export */ const queueAddMultipleItems_graphql = (QueueAddMultipleItemsDocument);

;// CONCATENATED MODULE: ./src/modules/queue/graph/queueMoveItem.graphql.ts
function queueMoveItem_graphql_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function queueMoveItem_graphql_array_without_holes(arr) {
    if (Array.isArray(arr)) return queueMoveItem_graphql_array_like_to_array(arr);
}
function queueMoveItem_graphql_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function queueMoveItem_graphql_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function queueMoveItem_graphql_to_consumable_array(arr) {
    return queueMoveItem_graphql_array_without_holes(arr) || queueMoveItem_graphql_iterable_to_array(arr) || queueMoveItem_graphql_unsupported_iterable_to_array(arr) || queueMoveItem_graphql_non_iterable_spread();
}
function queueMoveItem_graphql_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return queueMoveItem_graphql_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return queueMoveItem_graphql_array_like_to_array(o, minLen);
}





var QueueMoveItemDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "QueueMoveItem"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "mutationInput"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "QueueMoveItemInput"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "queueInput"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "QueueInput"
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "queueMoveItem"
                        },
                        "arguments": [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "mutationInput"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "queue"
                                    },
                                    "arguments": [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "input"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "queueInput"
                                                }
                                            }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "queueItems"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "QueueItem"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "error"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "QueueMoveItemError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "queueMoveItemErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "BusinessError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "businessErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "SecurityError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "securityErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "ServerError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "serverErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "ValidationError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "validationErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "QueueItem"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "QueueItem"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "month"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "year"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paid"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "canceled"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "statuses"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "tracking"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "number"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "products"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "flatIndex"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "queueItemId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "drift"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "name"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "image"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "description"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "scentOfMonthUid"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "tradingItem"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "volume"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "volume"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "unit"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "productInfo"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "url"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "image"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "rebrandImage"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "rebrandLabels"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "marketing"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "extra"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "characteristic"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "fullName"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "brandInfo"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "slug"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "category"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "typeGroup"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "gender"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "upchargePrice"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasLep"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasVariety"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "isSubscribedToStockNotification"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
QueueMoveItemDocument["definitions"] = queueMoveItem_graphql_to_consumable_array(new Set(QueueMoveItemDocument.definitions));
/* harmony default export */ const queueMoveItem_graphql = (QueueMoveItemDocument);

;// CONCATENATED MODULE: ./src/modules/queue/graph/queueDeleteItem.graphql.ts
function queueDeleteItem_graphql_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function queueDeleteItem_graphql_array_without_holes(arr) {
    if (Array.isArray(arr)) return queueDeleteItem_graphql_array_like_to_array(arr);
}
function queueDeleteItem_graphql_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function queueDeleteItem_graphql_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function queueDeleteItem_graphql_to_consumable_array(arr) {
    return queueDeleteItem_graphql_array_without_holes(arr) || queueDeleteItem_graphql_iterable_to_array(arr) || queueDeleteItem_graphql_unsupported_iterable_to_array(arr) || queueDeleteItem_graphql_non_iterable_spread();
}
function queueDeleteItem_graphql_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return queueDeleteItem_graphql_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return queueDeleteItem_graphql_array_like_to_array(o, minLen);
}





var QueueDeleteItemDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "QueueDeleteItem"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "mutationInput"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "QueueDeleteItemInput"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "queueInput"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "QueueInput"
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "queueDeleteItem"
                        },
                        "arguments": [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "mutationInput"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "queue"
                                    },
                                    "arguments": [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "input"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "queueInput"
                                                }
                                            }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "queueItems"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "QueueItem"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "error"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "QueueDeleteItemError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "queueDeleteItemErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "SecurityError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "securityErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "ServerError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "serverErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "ValidationError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "validationErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "QueueItem"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "QueueItem"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "month"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "year"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paid"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "canceled"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "statuses"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "tracking"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "number"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "products"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "flatIndex"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "queueItemId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "drift"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "name"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "image"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "description"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "scentOfMonthUid"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "tradingItem"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "volume"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "volume"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "unit"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "productInfo"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "url"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "image"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "rebrandImage"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "rebrandLabels"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "marketing"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "extra"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "characteristic"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "fullName"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "brandInfo"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "slug"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "category"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "typeGroup"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "gender"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "upchargePrice"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasLep"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasVariety"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "isSubscribedToStockNotification"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
QueueDeleteItemDocument["definitions"] = queueDeleteItem_graphql_to_consumable_array(new Set(QueueDeleteItemDocument.definitions));
/* harmony default export */ const queueDeleteItem_graphql = (QueueDeleteItemDocument);

;// CONCATENATED MODULE: ./src/modules/queue/graph/queueUpdateItem.graphql.ts
function queueUpdateItem_graphql_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function queueUpdateItem_graphql_array_without_holes(arr) {
    if (Array.isArray(arr)) return queueUpdateItem_graphql_array_like_to_array(arr);
}
function queueUpdateItem_graphql_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function queueUpdateItem_graphql_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function queueUpdateItem_graphql_to_consumable_array(arr) {
    return queueUpdateItem_graphql_array_without_holes(arr) || queueUpdateItem_graphql_iterable_to_array(arr) || queueUpdateItem_graphql_unsupported_iterable_to_array(arr) || queueUpdateItem_graphql_non_iterable_spread();
}
function queueUpdateItem_graphql_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return queueUpdateItem_graphql_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return queueUpdateItem_graphql_array_like_to_array(o, minLen);
}





var QueueUpdateItemDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "QueueUpdateItem"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "mutationInput"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "QueueUpdateItemInput"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "queueInput"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "QueueInput"
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "queueUpdateItem"
                        },
                        "arguments": [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "mutationInput"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "queue"
                                    },
                                    "arguments": [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "input"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "queueInput"
                                                }
                                            }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "queueItems"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "QueueItem"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "error"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "QueueUpdateItemError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "queueUpdateItemErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "SecurityError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "securityErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "ServerError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "serverErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "ValidationError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "validationErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "ProductValidationError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "productValidationErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "BusinessError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "businessErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "QueueItem"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "QueueItem"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "month"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "year"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paid"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "canceled"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "statuses"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "tracking"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "number"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "products"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "flatIndex"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "queueItemId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "drift"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "name"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "image"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "description"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "scentOfMonthUid"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "tradingItem"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "volume"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "volume"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "unit"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "productInfo"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "url"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "image"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "rebrandImage"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "rebrandLabels"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "marketing"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "extra"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "characteristic"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "fullName"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "brandInfo"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "slug"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "category"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "typeGroup"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "gender"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "upchargePrice"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasLep"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasVariety"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "isSubscribedToStockNotification"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
QueueUpdateItemDocument["definitions"] = queueUpdateItem_graphql_to_consumable_array(new Set(QueueUpdateItemDocument.definitions));
/* harmony default export */ const queueUpdateItem_graphql = (QueueUpdateItemDocument);

;// CONCATENATED MODULE: ./src/modules/queue/index.ts
function queue_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function queue_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function queue_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            queue_define_property(target, key, source[key]);
        });
    }
    return target;
}
function queue_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function queue_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        queue_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || queue_unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function queue_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return queue_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return queue_array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}









































var getClosestAvailableMonth = function(items) {
    return items.find(function(param) {
        var stateOptions = param.stateOptions;
        return !stateOptions.isDisabled;
    });
};
/**
 * serverIndex is unique ACTIVE product key
 * */ var getProductFromQueueByFlatIndex = function(serverIndex, items) {
    var item;
    items.some(function(param) {
        var products = param.products;
        item = products.find(function(param) {
            var flatIndex = param.flatIndex;
            return serverIndex === flatIndex;
        });
        return item;
    });
    return item;
};
var getLastAddedProductById = function(productId, items, position) {
    var itemsQuantity = items.length;
    for(var i = 0; i < itemsQuantity; i++){
        var itemIndex = position === "FIRST" ? i : itemsQuantity - i - 1;
        var productsQuantity = items[itemIndex].products.length;
        for(var j = 0; j < productsQuantity; j++){
            var _product_tradingItem;
            var productIndex = position === "FIRST" ? j : productsQuantity - j - 1;
            var product = items[itemIndex].products[productIndex];
            if (productId === (product === null || product === void 0 ? void 0 : (_product_tradingItem = product.tradingItem) === null || _product_tradingItem === void 0 ? void 0 : _product_tradingItem.id)) {
                return product;
            }
        }
    }
    return null;
};
// TODO temp fix for backend hard limit (24 months) in queue
//  for users with higher fullness of queue - added on 02.08.2022 by sonatskiy
var useQueueMinimalLimitRef = function() {
    var _user_analyticsMetadata;
    var user = (0,user_user/* useUser */.a)().user;
    var productsInQueueQty = (user === null || user === void 0 ? void 0 : (_user_analyticsMetadata = user.analyticsMetadata) === null || _user_analyticsMetadata === void 0 ? void 0 : _user_analyticsMetadata.productsInQueueQty) || 0;
    var queueMinimalLimitRef = (0,react.useRef)(null);
    queueMinimalLimitRef.current = Math.max(24, productsInQueueQty + 1);
    return queueMinimalLimitRef;
};
var useQueue = function() {
    var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _items__statuses, _items_;
    var queueMinimalLimitRef = useQueueMinimalLimitRef();
    var _useQuery = (0,useQuery/* default */.Z)(queue_graphql, {
        variables: {
            input: queue_object_spread({
                limit: queueMinimalLimitRef.current
            }, input)
        },
        ssr: false
    }), data = _useQuery.data, isFetching = _useQuery.isFetching, error = _useQuery.error, refetch = _useQuery.refetch;
    var items = (0,react.useMemo)(function() {
        var _data_currentUser_data_queue, _data_currentUser_data, _data_currentUser;
        var queueItems = data === null || data === void 0 ? void 0 : (_data_currentUser = data.currentUser) === null || _data_currentUser === void 0 ? void 0 : (_data_currentUser_data = _data_currentUser.data) === null || _data_currentUser_data === void 0 ? void 0 : (_data_currentUser_data_queue = _data_currentUser_data.queue) === null || _data_currentUser_data_queue === void 0 ? void 0 : _data_currentUser_data_queue.queueItems;
        if (queueItems) {
            return queue_modifyQueueItems(queue_filterEmptyQueueItems(queueItems));
        }
        return null;
    }, [
        data
    ]);
    var isEmpty = !isFetching && (items === null || items === void 0 ? void 0 : (_items_ = items[0]) === null || _items_ === void 0 ? void 0 : (_items__statuses = _items_.statuses) === null || _items__statuses === void 0 ? void 0 : _items__statuses.every(function(status) {
        return status === "EMPTY";
    }));
    return {
        items: items,
        isEmpty: isEmpty,
        isFetching: isFetching,
        refetch: refetch,
        error: error
    };
};
var getPostponedItems = function() {
    return local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.queuePendingProducts) || [];
};
var addItemsToPostponed = function(items) {
    var position = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "LAST";
    var postponedItems = local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.queuePendingProducts) || [];
    var existingIds = postponedItems.map(function(param) {
        var product = param.product;
        return product.tradingItemId;
    });
    items.forEach(function(item) {
        var product = item.product;
        if (existingIds.includes(product.tradingItemId)) {
            return;
        }
        if (position === "FIRST") {
            postponedItems.unshift(item);
        } else {
            postponedItems.push(item);
        }
    });
    local_storage/* default */.Z.setItem(constants/* default */.Z.localStorageNames.queuePendingProducts, postponedItems);
};
var getProductsInQueueQnt = function(data) {
    if (!data) {
        return null;
    }
    return data.queueItems.reduce(function(result, item) {
        var _item_products;
        return result + ((_item_products = item.products) === null || _item_products === void 0 ? void 0 : _item_products.length) || 0;
    }, 0);
};
var openAddedProductNotification = function(items, count) {
    var productProps;
    var isOnlyProduct = items.length === 1;
    if (isOnlyProduct) {
        var _items__product = items[0].product, name = _items__product.name, brand = _items__product.brand, image = _items__product.image, rebrandImage = _items__product.rebrandImage;
        productProps = {
            name: name,
            brand: brand,
            image: image,
            rebrandImage: rebrandImage
        };
    }
    (0,notifications_manager/* openNotification */.Ym)("productAdded", queue_object_spread({
        to: "queue",
        count: count
    }, productProps));
};
var updateQueueCache = function(cache, queueInput, queue) {
    if (!queue) {
        return;
    }
    cache.writeQuery({
        query: queue_graphql,
        variables: {
            input: queueInput
        },
        data: {
            currentUser: {
                data: {
                    queue: queue,
                    __typename: "UserData"
                },
                __typename: "UserPayload"
            }
        }
    });
};
// real adding to the queue with additional logic
var useQueueAddItemsBase = function() {
    var _subscription_plan, _shownPopups_addPremiumModal;
    var _useMutation = _sliced_to_array((0,useMutation/* default */.Z)(queueAddMultipleItems_graphql, {
        fetchPolicy: "no-cache"
    }), 2), mutate = _useMutation[0], _useMutation_ = _useMutation[1], isFetching = _useMutation_.isFetching, client = _useMutation_.client;
    var shownPopups = (0,user_shownPopups/* useShownPopups */.BP)().shownPopups;
    var subscription = (0,subscription_subscription/* useSubscription */.m)().subscription;
    var isOptInEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.optInPopups);
    var isCaseUpsellEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.caseUpsellAddToQueue);
    var isHereticCaseUpsellEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.caseUpsellHeretic);
    var queueMinimalLimitRef = useQueueMinimalLimitRef();
    // to keep useCallback unchanged
    var shownPopupsRef = (0,react.useRef)(shownPopups);
    shownPopupsRef.current = shownPopups;
    var isUpgradableFromMonthlyPlanRef = (0,react.useRef)(null);
    isUpgradableFromMonthlyPlanRef.current = subscription === null || subscription === void 0 ? void 0 : subscription.isUpgradableFromMonthlyPlan;
    var isSubscriptionAvailableForPEMRef = (0,react.useRef)(null);
    isSubscriptionAvailableForPEMRef.current = ((subscription === null || subscription === void 0 ? void 0 : subscription.isActive) || (subscription === null || subscription === void 0 ? void 0 : subscription.isPending)) && (subscription === null || subscription === void 0 ? void 0 : (_subscription_plan = subscription.plan) === null || _subscription_plan === void 0 ? void 0 : _subscription_plan.shippingPeriod) === 1;
    var isAddPremiumModalAvailableRef = (0,react.useRef)(null);
    isAddPremiumModalAvailableRef.current = !(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_addPremiumModal = shownPopups["addPremiumModal"]) === null || _shownPopups_addPremiumModal === void 0 ? void 0 : _shownPopups_addPremiumModal.lastUpdated);
    var isCaseSubscriptionUpsellModalAvailableRef = (0,react.useRef)(null);
    isCaseSubscriptionUpsellModalAvailableRef.current = (subscription === null || subscription === void 0 ? void 0 : subscription.isActive) && (subscription === null || subscription === void 0 ? void 0 : subscription.isCaseSubscriptionAvailable);
    var action = (0,react.useCallback)(function() {
        var _ref = _async_to_generator(function(items) {
            var params, _params_withNotification, withNotification, _params_withNonAuthRedirect, withNonAuthRedirect, _params_withUpgradeFlow, withUpgradeFlow, _params_withErrorModals, withErrorModals, withoutPremiumModal, _params_withCaseUpsellModal, withCaseUpsellModal, isOnlyProduct, queueItemAddInputList, isPlacementInvalid, queueInput, result, _result_data_queueAddMultipleItems, data, error, resultQueue, productsInQueueQty, itemError, item, _item_product, productId, isSubscribedToStockNotification, errorCode, customMessage, _getClosestAvailableMonth, _lastAddedProduct_tradingItem, queueItems, position, _items__product, tradingItemId, isLimitedEdition, upchargePrice, closestMonthProducts, lastAddedProduct, isMovedToClosestMonth, isLEPPutFirstInQueueModalVisible, LEPPutFirstModalProps, brandSlug, isOptInModalVisible, product, _checkUpsellModalCookie, isVisible, onClose, _checkUpsellModalCookie1, isVisible1, onClose1;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _params_withNotification = params.withNotification, withNotification = _params_withNotification === void 0 ? true : _params_withNotification, _params_withNonAuthRedirect = params.withNonAuthRedirect, withNonAuthRedirect = _params_withNonAuthRedirect === void 0 ? true : _params_withNonAuthRedirect, _params_withUpgradeFlow = params.withUpgradeFlow, withUpgradeFlow = _params_withUpgradeFlow === void 0 ? true : _params_withUpgradeFlow, _params_withErrorModals = params.withErrorModals, withErrorModals = _params_withErrorModals === void 0 ? true : _params_withErrorModals, withoutPremiumModal = params.withoutPremiumModal, _params_withCaseUpsellModal = params.withCaseUpsellModal, withCaseUpsellModal = _params_withCaseUpsellModal === void 0 ? false : _params_withCaseUpsellModal;
                        isOnlyProduct = items.length === 1;
                        queueItemAddInputList = items.map(function(param) {
                            var product = param.product, _param_force = param.force, force = _param_force === void 0 ? false : _param_force, metadata = param.metadata, _param_position = param.position, position = _param_position === void 0 ? "LAST" : _param_position;
                            return {
                                tradingItemId: product.tradingItemId,
                                force: force,
                                metadata: metadata,
                                position: position
                            };
                        });
                        isPlacementInvalid = queueItemAddInputList.some(function(param) {
                            var metadata = param.metadata;
                            return !(metadata === null || metadata === void 0 ? void 0 : metadata.placement) || /^[a-z]/.test(metadata.placement);
                        });
                        if (isPlacementInvalid) {
                            logger/* default */.Z.error({
                                items: items
                            }, "add to queue invalid placement");
                        }
                        queueInput = {
                            limit: queueMinimalLimitRef.current + queueItemAddInputList.length
                        };
                        return [
                            4,
                            mutate({
                                variables: {
                                    mutationInput: {
                                        queueItemAddInputList: queueItemAddInputList
                                    },
                                    queueInput: queueInput
                                },
                                update: function(cache, result) {
                                    var _result_data_queueAddMultipleItems_data;
                                    updateQueueCache(cache, queueInput, (_result_data_queueAddMultipleItems_data = result.data.queueAddMultipleItems.data) === null || _result_data_queueAddMultipleItems_data === void 0 ? void 0 : _result_data_queueAddMultipleItems_data.queue);
                                }
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.errors) {
                            throw new errors/* GraphQLError */.__(result.errors);
                        }
                        _result_data_queueAddMultipleItems = result.data.queueAddMultipleItems, data = _result_data_queueAddMultipleItems.data, error = _result_data_queueAddMultipleItems.error;
                        resultQueue = data === null || data === void 0 ? void 0 : data.queue;
                        productsInQueueQty = resultQueue ? getProductsInQueueQnt(resultQueue) : null;
                        if (productsInQueueQty !== null) {
                            client.cache.modify({
                                id: "PersonalInfo:{}",
                                fields: {
                                    analyticsMetadata: function(value) {
                                        return queue_object_spread_props(queue_object_spread({}, value), {
                                            productsInQueueQty: productsInQueueQty
                                        });
                                    }
                                }
                            });
                        }
                        if (error) {
                            if (error.__typename === "SecurityError" && error.securityErrorCode === "NOT_AUTHENTICATED") {
                                addItemsToPostponed(items);
                                if (withNonAuthRedirect) {
                                    throw new errors/* UserError */.gK(error);
                                }
                                throw new errors/* CancelledPromiseError */.as(error.message);
                            }
                            if (withErrorModals) {
                                if (error.__typename === "QueueAddMultipleItemsError") {
                                    itemError = error.errorDetails[0];
                                    item = items.find(function(param) {
                                        var tradingItemId = param.product.tradingItemId;
                                        return tradingItemId === itemError.tradingItemId;
                                    });
                                    _item_product = item.product, productId = _item_product.productId, isSubscribedToStockNotification = _item_product.isSubscribedToStockNotification;
                                    // TODO add queue error handling - added on 19.01.2022 by sonatskiy
                                    errorCode = itemError.businessErrorCode || itemError.productValidationErrorCode;
                                    if (errorCode === "UPCHARGE_NEED_PAYMENT_DATA") {
                                        (0,manager/* openModal */.h7)("needPaymentDataModal", {
                                            items: items
                                        });
                                        throw new errors/* CancelledPromiseError */.as();
                                    } else if (errorCode === "NO_SUBSCRIPTION" || errorCode === "NO_ACTIVE_SUBSCRIPTION") {
                                        (0,manager/* openModal */.h7)("activateAccountModal", {
                                            item: item
                                        });
                                        throw new errors/* CancelledPromiseError */.as();
                                    } else if (errorCode === "RESTRICT_SAME_PERFUME") {
                                        // TODO: Refactor error handling and add analytics — added on 02–04–2022 by algeas
                                        (0,manager/* openModal */.h7)("sameProductModal");
                                        throw new errors/* CancelledPromiseError */.as();
                                    } else if (errorCode === "LEP_OUT_OF_STOCK") {
                                        (0,manager/* openModal */.h7)("outOfStockModal", {
                                            productId: productId,
                                            isSubscribedToStockNotification: isSubscribedToStockNotification
                                        });
                                        throw new errors/* CancelledPromiseError */.as();
                                    } else if (errorCode === "SUBSCRIPTION_ON_HOLD") {
                                        (0,manager/* openModal */.h7)("cancelSkipModal", {
                                            item: item
                                        });
                                        throw new errors/* CancelledPromiseError */.as();
                                    }
                                    customMessage = itemError.message;
                                    throw new errors/* UserError */.gK(queue_object_spread_props(queue_object_spread({}, itemError), {
                                        errorCode: errorCode
                                    }), customMessage);
                                }
                                throw new errors/* UserError */.gK(error);
                            }
                            // otherwise, ignore errors and resolve promise
                            return [
                                2
                            ];
                        }
                        if (withNotification) {
                            if (isOnlyProduct) {
                                ;
                                queueItems = queue_modifyQueueItems(queue_filterEmptyQueueItems(resultQueue === null || resultQueue === void 0 ? void 0 : resultQueue.queueItems));
                                position = queueItemAddInputList[0].position;
                                _items__product = items[0].product, tradingItemId = _items__product.tradingItemId, isLimitedEdition = _items__product.isLimitedEdition, upchargePrice = _items__product.upchargePrice;
                                closestMonthProducts = (_getClosestAvailableMonth = getClosestAvailableMonth(queueItems)) === null || _getClosestAvailableMonth === void 0 ? void 0 : _getClosestAvailableMonth.products;
                                lastAddedProduct = getLastAddedProductById(tradingItemId, queueItems, position);
                                isMovedToClosestMonth = closestMonthProducts.some(function(param) {
                                    var flatIndex = param.flatIndex;
                                    return flatIndex === (lastAddedProduct === null || lastAddedProduct === void 0 ? void 0 : lastAddedProduct.flatIndex);
                                });
                                isLEPPutFirstInQueueModalVisible = isLimitedEdition && !isMovedToClosestMonth && isSubscriptionAvailableForPEMRef.current;
                                LEPPutFirstModalProps = isLEPPutFirstInQueueModalVisible ? {
                                    productIndex: lastAddedProduct === null || lastAddedProduct === void 0 ? void 0 : lastAddedProduct.flatIndex,
                                    onClose: function() {
                                        if (withNotification) {
                                            openAddedProductNotification(items, data === null || data === void 0 ? void 0 : data.productsAdded);
                                        }
                                    }
                                } : null;
                                brandSlug = lastAddedProduct === null || lastAddedProduct === void 0 ? void 0 : (_lastAddedProduct_tradingItem = lastAddedProduct.tradingItem) === null || _lastAddedProduct_tradingItem === void 0 ? void 0 : _lastAddedProduct_tradingItem.productInfo.brandInfo.slug;
                                isOptInModalVisible = isOptInEnabled && (0,optIn/* isOptInModalShouldBeShown */.UT)({
                                    brandSlug: brandSlug,
                                    shownPopups: shownPopupsRef.current
                                });
                                if (isOptInModalVisible) {
                                    (0,manager/* openModal */.h7)("brandOptInModal", {
                                        priority: 1,
                                        brandSlug: brandSlug,
                                        onClose: function() {
                                            if (withNotification) {
                                                openAddedProductNotification(items, data === null || data === void 0 ? void 0 : data.productsAdded);
                                            }
                                        }
                                    });
                                    return [
                                        2
                                    ];
                                }
                                if (lastAddedProduct && !withoutPremiumModal && upchargePrice && isAddPremiumModalAvailableRef.current) {
                                    (0,manager/* openModal */.h7)("addPremiumModal", {
                                        product: lastAddedProduct,
                                        onClose: function() {
                                            if (isLEPPutFirstInQueueModalVisible) {
                                                (0,manager/* openModal */.h7)("putFirstToQueueModal", LEPPutFirstModalProps);
                                            } else {
                                                if (withNotification) {
                                                    openAddedProductNotification(items, data === null || data === void 0 ? void 0 : data.productsAdded);
                                                }
                                            }
                                        }
                                    });
                                    return [
                                        2
                                    ];
                                }
                                if (isLEPPutFirstInQueueModalVisible) {
                                    (0,manager/* openModal */.h7)("putFirstToQueueModal", LEPPutFirstModalProps);
                                    return [
                                        2
                                    ];
                                }
                            } else {
                            // TODO: The logic of adding several products requires product development — added on 02–04–2022 by algeas
                            }
                        }
                        if (withUpgradeFlow && isUpgradableFromMonthlyPlanRef.current) {
                            if (productsInQueueQty % 6 === 0) {
                                (0,manager/* openModal */.h7)("addToQueueUpgradeModal");
                                if (withNotification) {
                                    openAddedProductNotification(items, data === null || data === void 0 ? void 0 : data.productsAdded);
                                }
                                return [
                                    2
                                ];
                            }
                        }
                        // code duplication to show this popup after upgrade
                        if (withNotification && isOnlyProduct && withCaseUpsellModal) {
                            product = items[0].product;
                            if (product.isVial && !product.is1_5mlVial) {
                                if (isHereticCaseUpsellEnabled && product.brand.toUpperCase().startsWith("HERETIC")) {
                                    _checkUpsellModalCookie = (0,checkUpsellModalCookie/* default */.Z)({
                                        cookieName: constants/* default */.Z.cookieNames.isHereticCaseUpsellModalShown,
                                        countPerDay: 5
                                    }), isVisible = _checkUpsellModalCookie.isVisible, onClose = _checkUpsellModalCookie.onClose;
                                    if (isVisible) {
                                        (0,manager/* openModal */.h7)("hereticCaseUpsellModal", {
                                            product: product,
                                            addTo: "queue",
                                            priority: 4,
                                            onClose: onClose
                                        });
                                        return [
                                            2
                                        ];
                                    }
                                } else if (isCaseUpsellEnabled && isCaseSubscriptionUpsellModalAvailableRef.current) {
                                    _checkUpsellModalCookie1 = (0,checkUpsellModalCookie/* default */.Z)({
                                        cookieName: constants/* default */.Z.cookieNames.isAddToQueueCaseUpsellModalShown,
                                        countPerDay: 2
                                    }), isVisible1 = _checkUpsellModalCookie1.isVisible, onClose1 = _checkUpsellModalCookie1.onClose;
                                    if (isVisible1) {
                                        (0,manager/* openModal */.h7)("caseSubscriptionUpsellModal", {
                                            priority: 4,
                                            onClose: onClose1
                                        });
                                    }
                                }
                            }
                            if (withNotification) {
                                openAddedProductNotification(items, data === null || data === void 0 ? void 0 : data.productsAdded);
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(items) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutate,
        client,
        queueMinimalLimitRef,
        isOptInEnabled,
        isCaseUpsellEnabled,
        isHereticCaseUpsellEnabled
    ]);
    return [
        action,
        {
            isFetching: isFetching
        }
    ];
};
var useQueueResolvePostponedItems = function() {
    var _useQueueAddItemsBase = _sliced_to_array(useQueueAddItemsBase(), 1), addItemsToQueue = _useQueueAddItemsBase[0];
    return (0,react.useCallback)(function(params) {
        var withLEP = params.withLEP, withPriorityProducts = params.withPriorityProducts;
        var postponedItems = local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.queuePendingProducts);
        // we can't add LEP items to users without subscription, so we keep the if we need
        var itemsToAdd = [];
        var itemsToKeep = [];
        postponedItems === null || postponedItems === void 0 ? void 0 : postponedItems.forEach(function(item) {
            if (withLEP || !item.product.isLimitedEdition) {
                itemsToAdd.push(item);
            } else {
                itemsToKeep.push(item);
            }
        });
        if (itemsToKeep.length) {
            local_storage/* default */.Z.setItem(constants/* default */.Z.localStorageNames.queuePendingProducts, itemsToKeep);
        } else {
            local_storage/* default */.Z.removeItem(constants/* default */.Z.localStorageNames.queuePendingProducts);
        }
        // first products in queue
        if (withPriorityProducts) {
            var highPriorityProducts = local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.queueHighPriorityProducts);
            var lowPriorityProducts = local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.queueLowPriorityProducts);
            local_storage/* default */.Z.removeItem(constants/* default */.Z.localStorageNames.queueHighPriorityProducts);
            local_storage/* default */.Z.removeItem(constants/* default */.Z.localStorageNames.queueLowPriorityProducts);
            highPriorityProducts === null || highPriorityProducts === void 0 ? void 0 : highPriorityProducts.forEach(function(item) {
                // because every high priority product has position FIRST, we reverse the adding
                itemsToAdd.unshift(item);
            });
            lowPriorityProducts === null || lowPriorityProducts === void 0 ? void 0 : lowPriorityProducts.forEach(function(item) {
                itemsToAdd.push(item);
            });
        }
        if (!itemsToAdd.length) {
            return Promise.resolve();
        }
        return addItemsToQueue(itemsToAdd, params);
    }, [
        addItemsToQueue
    ]);
};
// adding to queue logic for UI
var useQueueAddItems = function() {
    var history = (0,contexts/* useHistory */.k6)();
    var client = (0,useApolloClients/* useApolloClient */.x)();
    var _useQueueAddItemsBase = _sliced_to_array(useQueueAddItemsBase(), 2), addItemsToQueue = _useQueueAddItemsBase[0], state = _useQueueAddItemsBase[1];
    var isLoggedIn = (0,user_user/* useUser */.a)().isLoggedIn;
    var subscription = (0,subscription_subscription/* useSubscription */.m)().subscription;
    var isCardUpdateModalVisibleRef = (0,react.useRef)(null);
    isCardUpdateModalVisibleRef.current = subscription === null || subscription === void 0 ? void 0 : subscription.isUnpaid;
    var isResubscribeFlowAvailableRef = (0,react.useRef)(null);
    isResubscribeFlowAvailableRef.current = subscription === null || subscription === void 0 ? void 0 : subscription.isCancelled;
    var isLeadRef = (0,react.useRef)(null);
    isLeadRef.current = !subscription || subscription.hasNeverSubscribed;
    var action = (0,react.useCallback)(function() {
        var _ref = _async_to_generator(function(input) {
            var params, items, _params_withNonAuthRedirect, withNonAuthRedirect, _params_withResubscribeFlow, withResubscribeFlow;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                items = Array.isArray(input) ? input : [
                    input
                ];
                // withResubscribeFlow is disabled by default, because
                _params_withNonAuthRedirect = params.withNonAuthRedirect, withNonAuthRedirect = _params_withNonAuthRedirect === void 0 ? true : _params_withNonAuthRedirect, _params_withResubscribeFlow = params.withResubscribeFlow, withResubscribeFlow = _params_withResubscribeFlow === void 0 ? false : _params_withResubscribeFlow;
                if (isLeadRef.current) {
                    items.forEach(function(param) {
                        var product = param.product;
                        var productId = product.productId, brand = product.brand, name = product.name, gender = product.gender, category = product.category, productLabels = product.productLabels;
                        (0,analytics/* track */.j)("Lead add to queue", {
                            productId: productId,
                            productBrand: brand,
                            productFullName: "".concat(brand, " ").concat(name),
                            productGender: gender,
                            productCategory: category,
                            productLabels: productLabels
                        });
                    });
                }
                if (!isLoggedIn) {
                    addItemsToPostponed(items);
                    if (withNonAuthRedirect) {
                        history.push("".concat(links/* default */.ZP.register, "?redirect=").concat(encodeURIComponent(window.location.pathname + window.location.search)));
                        return [
                            2
                        ];
                    }
                    return [
                        2
                    ];
                }
                if (withResubscribeFlow && isResubscribeFlowAvailableRef.current && items.length === 1) {
                    (0,manager/* openModal */.h7)("resubscribeModal", {
                        productToAdd: items[0]
                    });
                    throw new errors/* CancelledPromiseError */.as("RESUBSCRIBE_FLOW");
                }
                if (isCardUpdateModalVisibleRef.current) {
                    (0,manager/* openModal */.h7)("cardUpdateModal", {
                        priority: 1,
                        flow: "Add to queue"
                    });
                    // We need to invalidate the cart cache to correctly display promo products in cart (PF-1519)
                    client.cache.evict({
                        id: "UserData:{}",
                        fieldName: "cart"
                    });
                    return [
                        2
                    ];
                }
                return [
                    2,
                    addItemsToQueue(items, params)
                ];
            });
        });
        return function(input) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addItemsToQueue,
        client,
        history,
        isLoggedIn
    ]);
    return [
        action,
        state
    ];
};
var useQueueMoveItem = function() {
    var _useMutation = _sliced_to_array((0,useMutation/* default */.Z)(queueMoveItem_graphql, {
        fetchPolicy: "no-cache"
    }), 2), mutate = _useMutation[0], _useMutation_ = _useMutation[1], isFetching = _useMutation_.isFetching, client = _useMutation_.client;
    var queueMinimalLimitRef = useQueueMinimalLimitRef();
    var moveItem = (0,react.useCallback)(function() {
        var _ref = _async_to_generator(function(mutationInput) {
            var queueInput, result, _result_data_queueMoveItem, error, queue;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // for analytics
                        // const product = getProductByFlatIndex(queueData.currentUser.data.queue.queueItems, fromFlatIndex)
                        queueInput = {
                            limit: queueMinimalLimitRef.current
                        };
                        return [
                            4,
                            mutate({
                                variables: {
                                    mutationInput: mutationInput,
                                    queueInput: queueInput
                                },
                                update: function(cache, result) {
                                    var _result_data_queueMoveItem;
                                    updateQueueCache(cache, queueInput, (_result_data_queueMoveItem = result.data.queueMoveItem) === null || _result_data_queueMoveItem === void 0 ? void 0 : _result_data_queueMoveItem.queue);
                                }
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.errors) {
                            throw new errors/* GraphQLError */.__(result.errors);
                        }
                        _result_data_queueMoveItem = result.data.queueMoveItem, error = _result_data_queueMoveItem.error, queue = _result_data_queueMoveItem.queue;
                        if (error) {
                            // TODO add LEP errors handling - added on 2021-06-16 by maddoger
                            throw new errors/* UserError */.gK(error);
                        }
                        // We need to invalidate the cart cache to correctly display promo products in cart (PF-1519)
                        client.cache.evict({
                            id: "UserData:{}",
                            fieldName: "cart"
                        });
                        return [
                            2,
                            queue_modifyQueueItems(queue_filterEmptyQueueItems(queue.queueItems))
                        ];
                }
            });
        });
        return function(mutationInput) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutate,
        client,
        queueMinimalLimitRef
    ]);
    return [
        moveItem,
        {
            isFetching: isFetching
        }
    ];
};
var useQueueUpdateItem = function() {
    var _useMutation = _sliced_to_array((0,useMutation/* default */.Z)(queueUpdateItem_graphql, {
        fetchPolicy: "no-cache"
    }), 2), mutate = _useMutation[0], _useMutation_ = _useMutation[1], isFetching = _useMutation_.isFetching, client = _useMutation_.client;
    var queueMinimalLimitRef = useQueueMinimalLimitRef();
    var updateItem = (0,react.useCallback)(function() {
        var _ref = _async_to_generator(function(mutationInput) {
            var queueInput, result, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        queueInput = {
                            limit: queueMinimalLimitRef.current
                        };
                        return [
                            4,
                            mutate({
                                variables: {
                                    mutationInput: mutationInput,
                                    queueInput: queueInput
                                },
                                update: function(cache, result) {
                                    var _result_data_queueUpdateItem;
                                    updateQueueCache(cache, queueInput, (_result_data_queueUpdateItem = result.data.queueUpdateItem) === null || _result_data_queueUpdateItem === void 0 ? void 0 : _result_data_queueUpdateItem.queue);
                                }
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.errors) {
                            throw new errors/* GraphQLError */.__(result.errors);
                        }
                        error = result.data.queueUpdateItem.error;
                        if (error) {
                            // TODO add LEP errors handling - added on 2021-06-16 by maddoger
                            if (error.__typename === "QueueUpdateItemError") {
                                if (error.queueUpdateItemErrorCode === "RESTRICT_SAME_PERFUME") {
                                    // TODO: Refactor error handling and add analytics — added on 02–04–2022 by algeas
                                    (0,manager/* openModal */.h7)("sameProductModal");
                                    throw new errors/* CancelledPromiseError */.as();
                                }
                            }
                            throw new errors/* UserError */.gK(error);
                        }
                        // We need to invalidate the cart cache to correctly display promo products in cart (PF-1519)
                        client.cache.evict({
                            id: "UserData:{}",
                            fieldName: "cart"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(mutationInput) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutate,
        client,
        queueMinimalLimitRef
    ]);
    return [
        updateItem,
        {
            isFetching: isFetching
        }
    ];
};
var useQueueDeleteItem = function() {
    var _useMutation = _sliced_to_array((0,useMutation/* default */.Z)(queueDeleteItem_graphql, {
        fetchPolicy: "no-cache"
    }), 2), mutate = _useMutation[0], _useMutation_ = _useMutation[1], isFetching = _useMutation_.isFetching, client = _useMutation_.client;
    var queueMinimalLimitRef = useQueueMinimalLimitRef();
    var deleteItem = (0,react.useCallback)(function() {
        var _ref = _async_to_generator(function(mutationInput) {
            var queueInput, result, _result_data_queueDeleteItem, queue, error, productsInQueueQty;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        queueInput = {
                            limit: queueMinimalLimitRef.current
                        };
                        return [
                            4,
                            mutate({
                                variables: {
                                    mutationInput: mutationInput,
                                    queueInput: queueInput
                                },
                                update: function(cache, result) {
                                    var _result_data_queueDeleteItem;
                                    updateQueueCache(cache, queueInput, (_result_data_queueDeleteItem = result.data.queueDeleteItem) === null || _result_data_queueDeleteItem === void 0 ? void 0 : _result_data_queueDeleteItem.queue);
                                }
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.errors) {
                            throw new errors/* GraphQLError */.__(result.errors);
                        }
                        _result_data_queueDeleteItem = result.data.queueDeleteItem, queue = _result_data_queueDeleteItem.queue, error = _result_data_queueDeleteItem.error;
                        if (error) {
                            // TODO add LEP errors handling - added on 2021-06-16 by maddoger
                            throw new errors/* UserError */.gK(error);
                        }
                        productsInQueueQty = getProductsInQueueQnt(queue);
                        // We need to invalidate the cart cache to correctly display promo products in cart (PF-1519)
                        client.cache.evict({
                            id: "UserData:{}",
                            fieldName: "cart"
                        });
                        client.cache.modify({
                            id: "PersonalInfo:{}",
                            fields: {
                                analyticsMetadata: function(value) {
                                    return queue_object_spread_props(queue_object_spread({}, value), {
                                        productsInQueueQty: productsInQueueQty
                                    });
                                }
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(mutationInput) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutate,
        client,
        queueMinimalLimitRef
    ]);
    return [
        deleteItem,
        {
            isFetching: isFetching
        }
    ];
};


/***/ })

}]);